import { coreService } from "../../services/coreService";
import { buildQuery } from "../../lib/network";

export type GetCrmListFieldDefinitionsParamsType = Omit<
  Parameters<(typeof coreService)["crmSearchDemoCreate"]>[0],
  "cursor"
>;
type RemoveEmptyConditions<T extends "Empty" | "NotEmpty" | string> = Exclude<T, "Empty" | "NotEmpty">;
export type DataFilterGroupType = GetCrmListFieldDefinitionsParamsType["filters"];
export type DataFilterType = Exclude<DataFilterGroupType, undefined>["filters"][number];
export type DateCondition = Extract<DataFilterType, { type: "Date" | "DateTime" | "Time" }>["dateCondition"];
export type DateConditionWithoutEmpty = RemoveEmptyConditions<DateCondition>;
export type NumberCondition = Extract<DataFilterType, { type: "Number" | "Currency" | "Percent" }>["numberCondition"];
export type NumberConditionWithoutEmpty = RemoveEmptyConditions<NumberCondition>;
export type StringCondition = Extract<
  DataFilterType,
  { type: "Text" | "TextArea" | "Email" | "URL" | "PhoneNumber" | "Address" }
>["stringCondition"];
export type StringConditionWithoutEmpty = RemoveEmptyConditions<StringCondition>;
export type BooleanCondition = Extract<DataFilterType, { type: "Checkbox" }>["booleanCondition"];
export type DropdownCondition = Extract<
  DataFilterType,
  { type: "Dropdown" | "DropdownMultiSelect" | "LookUp" }
>["dropdownCondition"];
export type DropdownConditionWithoutEmpty = RemoveEmptyConditions<DropdownCondition>;

export const getCrmRequests =
  (headers: any) =>
  ({ take, query, filters, sort }: GetCrmListFieldDefinitionsParamsType, cursor?: any[]) => {
    return buildQuery(
      coreService.crmSearchDemoCreate(
        {
          take,
          cursor,
          query,
          filters,
          sort,
        },
        { headers },
      ),
      (response) => {
        return response.data;
      },
    );
  };
